import type { Whitelabel, WhitelabelStore, WhitelabelConfig } from '@layers/web/stores/types/whitelabel.ts'
import { whitelabelConfigs } from '@layers/web/constants/whitelabel.ts'
import type { AgentCookie } from '@layers/web/stores/types/root.ts'

const useWhitelabelStore = defineStore('whitelabel', {
  state: (): WhitelabelStore => ({
    whitelabel: null,
  }),
  getters: {
    getWhitelabelConfig (state: WhitelabelStore): WhitelabelConfig | null {
      const whitelabel = state.whitelabel

      if (!whitelabel) {
        return null
      }

      return whitelabelConfigs[whitelabel]
    },

    getAllWebCodes () {
      return Object.values(whitelabelConfigs)
        .filter(item => item && item.webCode)
        .map(item => item.webCode)
    },
  },
  actions: {
    setWhiteLabel (whitelabel: Whitelabel) {
      const { locale } = useLocaleStore()
      const rootStore = useRootStore()

      if (!whitelabel) {
        return
      }

      const whitelabelConfig = whitelabelConfigs[whitelabel]
      const env = process.env.NODE_ENV

      if (!whitelabelConfig?.market.includes(locale as string)) {
        if (env === 'development') {
          console.info('Whitelabel not found or not allowed for this market', whitelabel)
        }

        this.whitelabel = null
        return
      }

      if (whitelabelConfig.market.includes(locale as string)) {
        if (env === 'development') {
          console.info('Whitelabel found and allowed for this market', whitelabel)
        }

        this.whitelabel = whitelabel
        rootStore.handleAgentCookie(whitelabelConfig.webCode)
      } else {
        if (env === 'development') {
          console.info('Whitelabel not found or not allowed for this market', whitelabel)
        }

        this.whitelabel = null
      }
    },

    checkAgentCookie () {
      const rootStore = useRootStore()
      const agentCookie = useCookie<AgentCookie | null>('a')

      const allWhitelabelAgentCodes = this.getAllWebCodes
      const cookie = agentCookie?.value

      if (!cookie) {
        return
      }

      if (!allWhitelabelAgentCodes.includes(cookie.code)) {
        return
      }

      if (this.whitelabel) {
        return
      }

      agentCookie.value = null

      rootStore.setAgentCookie(null)
    },
  },
})

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useWhitelabelStore, import.meta.hot))
}

export { useWhitelabelStore }